import matchPath from 'react-router/matchPath';

export default function matchRoutes(routes, pathname, parent) {
  var match = null;
  var route = null;
  var routeLength = routes.length;
  var r = 0;
  while (match == null && r < routeLength) {
    match = matchPath(pathname, routes[r], parent);
    if (match) {
      route = routes[r];
    }
    r++;
  }

  return { match: match, route: route };
}


//////////////////
// WEBPACK FOOTER
// ./~/rrc/es/helpers/matchRoutes.js
// module id = 616
// module chunks = 0